import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const ConclusionSection = () => (
  <View pageBreakAfter id="17">
    <Text bold size="small">
      17. CONCLUSÃO
    </Text>

    <Separator weight={4} />

    <Text>
      A ergonomia é o estudo da adaptação do trabalho ao homem, ou seja, é o estudo do relacionamento entre o homem e o
      meio laboral, equipamento e ambiente, e particularmente, a aplicação dos conhecimentos de anatomia, fisiologia e
      psicologia na solução dos problemas surgidos desse relacionamento.
      <br />
      Esta avaliação teve como finalidade principal identificar as deficiências, pontos de melhorias e de adequações
      regulamentares existentes BANCO SANTANDER DO BRASIL S.A, em especial nos postos de trabalho estudados acima.
      <br />
      A medida de controle indicada faz-se sempre necessário a principal fase que é a Prevenção e Educação dos
      colaboradores, para que não atuemos de forma corretiva às DORT.
      <br />
      Instruir os colaboradores quanto aos agentes ergonômicos capazes de causar algum dano à saúde é o início de um
      processo de melhoria, já que o fator humano tem peso expressivo nas questões ergonômicas.
      <br />
      Deverão ser observadas em cada item avaliado anteriormente as melhorias indicadas nas recomendações técnicas. As
      modificações para melhorias ergonômicas são processos que demandam planejamento por parte do BANCO SANTANDER DO
      BRASIL S.A.
      <br />
      Sendo dessa forma, alinhar um plano de ação ao planejamento estabelecido neste documento para que após um ciclo de
      ações o mesmo possa ser reavaliado.
      <br />A tabela de Cargos e Mapeamento de Riscos Ergonômicos de mapeamento indica a possibilidade de exposição dos
      colaboradores aos agentes de características ergonômicas.
    </Text>

    <Separator weight={8} />
  </View>
)

export default ConclusionSection
